import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./DLNavbar.css";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
// import { fetchAdminUser } from "./Redux/AdminUserSlice";
import { useTabContext } from "../../../TabContext";
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

const DLNavbar = ({userRoles}) => {
  const {setActivePage} = useTabContext()

 const [isMenu, setisMenu] = useState(false);
 const [isResponsiveclose, setResponsiveclose] = useState(false);

 const toggleClass = () => {
  setisMenu(isMenu === false ? true : false);
  setResponsiveclose(isResponsiveclose === false ? true : false);
 };
 let boxClass = ["main-menu"];
 if (isMenu) {
  boxClass.push("menuq2");
 } else {
  boxClass.push("");
 }

 return (
  <header className="header__middle">
   <div className="head-container">
    <div className="row-fluid">
     <div className="header__middle__menus">
      <nav className="main-nav ">
       {/* Responsive Menu Button */}
       {isResponsiveclose === true ? (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiXCircle />
         </span>
        </>
       ) : (
        <>
         <span
          className="menubar__button"
          style={{ display: "none" }}
          onClick={toggleClass}
         >
          <FiAlignRight />
         </span>
        </>
       )}
       <ul className={boxClass.join(" ")}>
        <li className="menu-item">
         <NavLink
          activeClassName="is-active"
          className="nav-links"
          onClick={toggleClass}
          to={"/delivery-leadership/requestor"}
         >
          Delivery Leadership Nominations
         </NavLink>
        </li>
        {userRoles.includes("th") ? (
         <li className="menu-item">
          <NavLink
           to="/delivery-leadership/TH"
           activeClassName="is-active"
           className="nav-links"
           onClick={() => {toggleClass(); setActivePage(false)}}

          >
           TH
          </NavLink>
         </li>
        ) : null}
       </ul>
      </nav>
     </div>
    </div>
   </div>
  </header>
 );
};

export default DLNavbar;
